<!-- <app-marquee #marquee id="marquee" [isShowTime]="true">
</app-marquee> -->
<!-- [barGroupWidth]="barGroupWidth" jk-grid-cols-4 -->
<div class="flex">
  <app-jkautocomplete #stklg004Com [width]="160" label="商品代號" [showClearButton]="true" valueExpr="id" displayExpr="name"
    [itemList]="stkmaIdNameList" [(value)]="stockno">
  </app-jkautocomplete>
  <div>
    <app-jkcombobox #stklg002Com [width]="160" label="資料頻率" [items]="stklg002List" displayExpr="name" valueExpr="id"
      [(value)]="stklg002">
    </app-jkcombobox>
  </div>
  <div>
    <app-jkcombobox #stock_range [width]="160" label="期間" [items]="stockRangeList" displayExpr="name" valueExpr="id"
      [(value)]="stockRange">
    </app-jkcombobox>
  </div>
  <button class="btn" [class.btn-outline-primary]="true" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
    <mat-icon>more_vert</mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="doScreenCapture()">
    <span>截圖</span>
  </button>
  <button mat-menu-item (click)="doShowJson(candleList)">
    <span>candleList</span>
  </button>
  <button mat-menu-item (click)="doTest1()">
    <span>test1</span>
  </button>
  <button mat-menu-item (click)="doTest2()">
    <span>test2</span>
  </button>
</mat-menu>
<div style="text-align:center">
  <apx-chart [lang]="'zh-tw'" [plotOptions]="chartOptions.plotOptions" [series]="chartOptions.series"
    [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis" [title]="chartOptions.title"
    [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"></apx-chart>
</div>
<mat-tab-group [(selectedIndex)]="kindIndex">
  @for (tab of kindList; track tab) {
  <mat-tab [label]="tab.name"></mat-tab>
  }
</mat-tab-group>
@if(view01Visible){
<app-stock-view01 class="max-[300px]" #view1 view1 [data]="stockData"></app-stock-view01>
}
@if(volumeVisible){
<app-volume-chart #volumechart [itemList]="stklgList">
</app-volume-chart>
}
@if(kdVisible){
<app-kd-chart #kdchart [itemList]="stklgList">
</app-kd-chart>
}
@if(macdVisible){
<app-macd-chart #macdchart [itemList]="stklgList">
</app-macd-chart>
}